;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/Forms/RecaptchaApiLoader',["eventManager"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("eventManager")) :
    console && console.log('Recaptcha API Loader works only in AMD')
}(this/* window */, function (eventManager) { 
    "use strict";
    // Trigger event when Google Recaptcha Api is loaded so all forms can render their own captchas
    window['onRecaptchaApiLoaded'] = function () { return eventManager.trigger("RecaptchaApiLoaded"); };
    require(['https://www.google.com/recaptcha/api.js?onload=onRecaptchaApiLoaded&render=explicit'], function () { return console.log("Recaptcha api is loaded."); });
}));
